/** @flow */
import type { Action } from '../types/Action';
import Notification from '../domain/Notification';

export const OPEN_SNACKBAR = 'ui/OPEN_SNACKBAR';
export const CLOSE_SNACKBAR = 'ui/CLOSE_SNACKBAR';

export const PUSH_NOTIFICATION = 'ui/PUSH_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'ui/REMOVE_NOTIFICATION';
export const UPDATE_NOTIFICATION = 'ui/UPDATE_NOTIFICATION';
export const READ_NOTIFICATION = 'ui/READ_NOTIFICATION';
export const CLEAR_NOTIFICATIONS = 'ui/CLEAR_NOTIFICATIONS';

export const openSnackbar = (kind: string, message: string): Action => ({
  type: OPEN_SNACKBAR,
  kind,
  message,
});

export const closeSnackbar = (): Action => ({
  type: CLOSE_SNACKBAR,
});

export const pushNotification = (notification: Notification) => {
  return ({
    type: PUSH_NOTIFICATION,
    notification,
  });
};

export const removeNotification = (notification: Notification) => ({
  type: REMOVE_NOTIFICATION,
  notification,
});

export const clearNotifications = () => ({
  type: CLEAR_NOTIFICATIONS,
});


export const updateNotification = (notification: Notification) => ({
  type: UPDATE_NOTIFICATION,
  notification,
});

export const readNotification = (reference: string) => ({
  type: READ_NOTIFICATION,
  reference,
});



// WEBPACK FOOTER //
// ./src/common/modules/ui/actions/uiActions.js